export default {
  data() {
    return {
      objetoFiltro: {
        unimeds: [],
        estados: [],
        unimed: {
          descricao: "",
          chave: ""
        },
        statusPrestador: {
          descricao: "",
          chave: ""
        },
        tipoPrestador: {
          descricao: "",
          chave: ""
        },
        competencia: "",
        dataInicio: "",
        dataFim: ""
      },
      habilitado: false,
      loading: false
    };
  },
  methods: {
    /**
     * Função base para não ter muitas duplicadas nos componentes de filtro,
     * facilitando assim a assosiação dos objetos no formato { chave: Number, descricao: String }
     * @param {Number, String} index - o index da listagem que está no autocomplete
     * @param {String} nomeObjeto - nome do objeto que está presente na variável objetoFiltro
     * @param {Array<Object>} listagem - listagem onde nós vamos extrair a chave
     */
    selecionarChave(index, nomeObjeto, listagem, nomeChave = "chave") {
      if ([undefined, null, "", -1].includes(index)) {
        this.objetoFiltro[nomeObjeto].chave = "";
        return;
      }

      this.objetoFiltro[nomeObjeto].chave = listagem[index][nomeChave];
    },
    proximaAba() {
      this.$children[0].$refs.observer.validate().then(res => {
        if (!res) return;

        this.$emit("proxima-aba-filtro");
      });
    },
    validarCampos() {
      let observer = this.$children[0].$refs.observer;
      observer
        .validate({
          silent: true
        })
        .then(res => {
          this.habilitado = res;
          this.$emit("habilitar-step", res);

          if (res) {
            this.$emit("recuperar-objeto-filtro", this.objetoFiltroMontado);
          }
        });
    },
    verificarData(dataArg) {
      const dataAgora = new Date();

      const mesNumero = +dataArg.split("/")[0] - 1;
      const anoNumero = +dataArg.split("/")[1];

      const dataPassada = new Date();
      dataPassada.setMonth(mesNumero);
      dataPassada.setFullYear(anoNumero);

      if (dataAgora < dataPassada) return true;

      return false;
    }
  },
  computed: {
    objetoFiltroMontado() {
      const {
        unimeds,
        estados,
        unimed: { chave: codigoUnimed, descricao: nomeUnimed },
        statusPrestador: {
          chave: chavePrestador,
          descricao: descricaoPrestador
        },
        tipoPrestador: {
          chave: chaveTipoPrestador,
          descricao: descricaoTipoPrestador
        },
        competencia,
        dataInicio,
        dataFim
      } = this.objetoFiltro;

      const checkData = this.verificarData(competencia);

      if (checkData) {
        this.$store.commit("setErro", {
          mostrarErro: true,
          titulo: "Oops, algo deu errado.",
          codigoErro: 406,
          mensagemErro: "Não é possivel acessar uma data futura."
        });
        return (this.objetoFiltro.competencia = "");
      }

      return {
        cdUnimeds: unimeds.map(({ id }) => id),
        ufs: estados.map(({ chave }) => chave),
        unimeds,
        estados,
        codigoUnimed,
        nomeUnimed,
        competencia: competencia
          ? this.$helpers.formatadorISO(competencia, "YYYY-MM", "MM/YYYY")
          : "",
        chavePrestador,
        descricaoPrestador,
        chaveTipoPrestador,
        descricaoTipoPrestador,
        dataInicio: dataInicio
          ? this.$helpers.formatadorISO(dataInicio, "YYYY-MM-DD", "DD/MM/YYYY")
          : "",
        dataFim: dataFim
          ? this.$helpers.formatadorISO(dataFim, "YYYY-MM-DD", "DD/MM/YYYY")
          : ""
      };
    }
  },
  watch: {
    ["objetoFiltro"]: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$children[0].$refs.observer) return;
          this.validarCampos();
        });
      }
    }
  }
};
